import axios from 'axios'

const state = {
  tags: [],
  filteredTags: [],
  // Transitive hierarchical-ancestor map {tagId: [ancestorTagId,...]} for the
  // bbox "narrow by" facet filter. Keyed by tag id, populated from
  // GET /api/tags/hierarchy/; empty for non-hierarchical tenants.
  ancestorMap: {},
  // selectedTags: []
}

const getters = {
  getTagNames () {
    return state.tags.map(tag => tag.name)
  },
  // IT-704 (P4): tags the tagger/QC input controls should show — the full list
  // unless derivation is enabled, in which case tags whose category is
  // machine-owned (derived) are hidden.
  visibleTags (state, getters, rootState, rootGetters) {
    if (!rootState.settings.hierarchicalTaggingEnabled) return state.tags
    const hidden = rootGetters.hierarchicalCategoryIds
    return state.tags.filter(tag => !(tag.category && hidden.has(tag.category.id)))
  },
  // Strip machine-owned (derived) tags from a list of tag OBJECTS. Used to seed
  // editors and to build full-set save payloads, so that when derivation is
  // enabled a save carries only human-picked tags and the backend re-derives the
  // rest. A no-op when derivation is off, so payloads round-trip unchanged. This
  // is the guard against the P4 save-path trap: hidden tags are omitted ONLY
  // when the backend is recomputing them.
  retainHumanTags (state, getters, rootState, rootGetters) {
    return (tags) => {
      if (!rootState.settings.hierarchicalTaggingEnabled) return tags || []
      const hidden = rootGetters.hierarchicalCategoryIds
      return (tags || []).filter(tag => !(tag.category && hidden.has(tag.category.id)))
    }
  }
}

const mutations = {
  setTags (state, tags) {
    state.tags = tags
  },
  setFilteredTags (state, tags) {
    state.filteredTags = tags
  },
  // setSelectedTags (state, tags) {
  //   state.selectedTags = tags
  // },
  addTag (state, tag) {
    state.tags.push(tag)
  },
  updateTag (state, payload) {
    const index = state.tags.findIndex(item => item.id === payload.id)
    if (index !== -1) state.tags.splice(index, 1, payload)
  },
  deleteTag (state, id) {
    var index = state.tags.findIndex(tag => tag.id === id)
    state.tags.splice(index, 1)
  },
  setAncestorMap (state, map) {
    state.ancestorMap = map || {}
  }
}

const actions = {
  getTagsList (context) {
    return axios.get('/api/tags')
      .then(response => {
        context.commit('setTags', response.data)
      })
      .catch(e => { console.log(e) })
  },
  getTagHierarchy (context) {
    return axios.get('/api/tags/hierarchy/')
      .then(response => {
        context.commit('setAncestorMap', (response.data && response.data.ancestors) || {})
      })
      .catch(e => { console.log(e) })
  },
  createTag (context, payload) {
    return axios.post('/api/tags/', payload)
      .then(response => {
        context.commit('addTag', response.data)
      })
      .catch(e => { console.log(e) })
  },
  updateTag (context, payload) {
    return axios.patch(`/api/tags/${payload.id}/`, payload)
      .then(response => {
        context.commit('updateTag', response.data)
      })
      .catch(e => { console.log(e) })
  },
  mergeTag (context, payload) {
    return axios.post(`/api/tags/${payload.id}/merge_tags/`, payload)
      .then(response => {
        context.commit('deleteTag', payload.id)
      })
      .catch(e => { console.log(e) })
  },
  deleteTag (context, payload) {
    return axios.delete(`/api/tags/${payload.id}/`, payload)
      .then(response => {
        context.commit('deleteTag', payload.id)
      })
      .catch(e => { console.log(e) })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
